import { createSlice } from "@reduxjs/toolkit";
import { getSecureLocalItem, setSecureLocalItem, removeSecureLocalItem } from "utils/secureSessionStorage";

const initialState = {
  loading: false,
  error: null,
  subscription: getSecureLocalItem("subscription") || null,
  features: getSecureLocalItem("subscription_features") || [],
  permissions: getSecureLocalItem("subscription_permissions") || [],
  createSuccess: false,
  hasSubscription: !!getSecureLocalItem("subscription"),
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    // Create Subscription
    createSubscriptionStart: (state) => {
      state.loading = true;
      state.error = null;
      state.createSuccess = false;
    },
    createSubscriptionSuccess: (state, action) => {
      state.loading = false;
      state.subscription = action.payload;
      state.createSuccess = true;
      state.hasSubscription = true;
      state.error = null;
    },
    createSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.createSuccess = false;
    },

    // Get User Subscription
    getUserSubscriptionStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getUserSubscriptionSuccess: (state, action) => {
      state.loading = false;
      state.subscription = action.payload.subscription;
      state.features = action.payload.features || [];
      state.permissions = action.payload.permissions || [];
      state.hasSubscription = true;
      state.error = null;
      setSecureLocalItem("subscription", action.payload.subscription);
      setSecureLocalItem("subscription_features", action.payload.features || []);
      setSecureLocalItem("subscription_permissions", action.payload.permissions || []);
      // console.log("✅ Redux State Updated - Subscription:", state.subscription);
      // console.log("✅ Plan name in Redux:", state.subscription?.plan_name);
    },
    getUserSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.hasSubscription = false;
      state.subscription = null;
      state.features = [];
      state.permissions = [];
      removeSecureLocalItem("subscription");
      removeSecureLocalItem("subscription_features");
      removeSecureLocalItem("subscription_permissions");
    },

    // Clear State
    clearSubscriptionError: (state) => {
      state.error = null;
    },
    clearCreateSuccess: (state) => {
      state.createSuccess = false;
    },
  },
});

export const {
  createSubscriptionStart,
  createSubscriptionSuccess,
  createSubscriptionFailure,
  getUserSubscriptionStart,
  getUserSubscriptionSuccess,
  getUserSubscriptionFailure,
  clearSubscriptionError,
  clearCreateSuccess,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
